import { useUpdateEffect } from '@cian/react-utils';

import { useGetOffersByActivePinQuery } from '@/packages/query-state/shared/store/search-offers/v1/get-offers-by-pin/query';
import {
  useActivePinIdSelector,
  useActivePinPageSelector,
} from '@/packages/redux-state/store/slices/mapControls/selectors/dumb';

/**
 * @description Обновляем выдачу по пину, когда меняется пагинация.
 * При этом проверяем на наличие значения "activePinId", иначе при возврате с выдачи по пину на главный
 * листинг получим перезапрос данных (т.к. сортировка и пагинация будут сброшены в дефолт)
 */
export function useUpdateOnPageChanged(): void {
  const { refetch: refetchGetOffersByPin } = useGetOffersByActivePinQuery({ notifyOnChangeProps: [] });

  const activePinId = useActivePinIdSelector();
  const page = useActivePinPageSelector();

  useUpdateEffect(() => {
    if (activePinId) {
      refetchGetOffersByPin();
    }
  }, [page]);
}
